/**
 * 详情页返回：进入时在 query 带上 return=进入前的 fullPath（由路由自动编码）。
 * 合同：contractDetailLocation；项目：projectDetailLocation。
 */

function normalizeReturnFullPath(fullPath) {
  if (fullPath == null || typeof fullPath !== 'string') return ''
  const s = fullPath.trim()
  if (!s.startsWith('/') || s.startsWith('//')) return ''
  if (/^javascript:/i.test(s)) return ''
  return s.length <= 2000 ? s : ''
}

/**
 * @param {string|number} contractId
 * @param {string} [returnFullPath] 当前页的 $route.fullPath
 * @returns {{ path: string, query?: { return: string } }}
 */
export function contractDetailLocation(contractId, returnFullPath) {
  const id = Number(contractId)
  if (!Number.isFinite(id)) {
    return { path: '/contract/list' }
  }
  const path = `/contract/detail/${id}`
  const ret = normalizeReturnFullPath(returnFullPath)
  if (ret) {
    return { path, query: { return: ret } }
  }
  return { path }
}

/**
 * @param {string|number} projectId
 * @param {string} [returnFullPath] 当前页的 $route.fullPath
 * @returns {{ path: string, query?: { return: string } }}
 */
export function projectDetailLocation(projectId, returnFullPath) {
  const id = Number(projectId)
  if (!Number.isFinite(id)) {
    return { path: '/project/list' }
  }
  const path = `/project/detail/${id}`
  const ret = normalizeReturnFullPath(returnFullPath)
  if (ret) {
    return { path, query: { return: ret } }
  }
  return { path }
}

/**
 * @param {string|string[]|undefined|null} queryVal $route.query.return
 * @returns {string|null} 安全可用的 path+query，否则 null
 */
export function decodeReturnQuery(queryVal) {
  if (queryVal == null || queryVal === '') return null
  const raw = Array.isArray(queryVal) ? queryVal[0] : queryVal
  const decoded = String(raw).trim()
  if (!decoded.startsWith('/') || decoded.startsWith('//')) return null
  if (/^javascript:/i.test(decoded)) return null
  return decoded.length <= 2000 ? decoded : null
}
